import React from 'react';
import moment from 'moment';
import 'moment/locale/es';
import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { checkAvailability } from '../../../actions/checkAvailability';
import { experienceSchedule, firstExperienceDate, isExperienceDateScheduled, scheduleWeekdays } from '../../../helpers/experienceSchedule';
import s from './ExperienceCalendar.css';

const weekdays = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

export class ExperienceCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { month: moment(firstExperienceDate(props.experiencePayload) || undefined).startOf('month') };
  }

  select = async day => {
    if (!this.canSelect(day)) return;
    const { formName, change, checkAvailability, listId } = this.props;
    const payment = formName === 'PaymentFormModal';
    // The shared booking contract uses equal start/end dates for a single session.
    change(formName, payment ? 'checkIn' : 'startDate', moment(day));
    change(formName, payment ? 'checkOut' : 'endDate', moment(day));
    await checkAvailability(listId, day, day, 0, 0);
  };

  canSelect = day => isExperienceDateScheduled(day, this.props.experiencePayload) &&
    !(this.props.blockedDates || []).some(item => item.calendarStatus !== 'available' && moment(item.blockedDates).format('YYYY-MM-DD') === day);

  renderMonth(month) {
    const { selectedDate } = this.props;
    const selected = selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : null;
    const blanks = (month.day() + 6) % 7;
    return <div className={s.month} key={month.format('YYYY-MM')}>
      <h3>{month.clone().locale('es').format('MMMM YYYY')}</h3>
      <div className={s.days}>
        {['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'].map(label => <span key={label} className={s.weekday}>{label}</span>)}
        {Array.from({ length: blanks }, (_, index) => <span key={`blank${index}`} />)}
        {Array.from({ length: month.daysInMonth() }, (_, index) => {
          const date = month.clone().date(index + 1).format('YYYY-MM-DD');
          const available = this.canSelect(date);
          return <button type="button" key={date} disabled={!available} aria-pressed={date === selected}
            aria-label={`${moment(date).locale('es').format('dddd D [de] MMMM [de] YYYY')}: ${available ? 'fecha programada' : 'no disponible'}`}
            className={`${s.day} ${available ? s.scheduled : ''} ${selected === date ? s.selected : ''}`}
            onClick={() => this.select(date)}>{index + 1}</button>;
        })}
      </div>
    </div>;
  }

  render() {
    const { experiencePayload, compact, selectedDate, loading } = this.props;
    const schedule = experienceSchedule(experiencePayload);
    const { month } = this.state;
    const next = firstExperienceDate(experiencePayload);
    const description = schedule && (schedule.calendar === 'everyDay' ? 'Todos los días' : schedule.calendar === 'specificDays'
      ? scheduleWeekdays(schedule.days).map(day => weekdays[day]).join(', ') : 'Fechas específicas definidas por el anfitrión');
    return <section id={!compact ? 'fechas-experiencia' : undefined} className={s.calendar} aria-label="Fechas de la experiencia">
      <h2>{compact ? 'Elige una fecha programada' : 'Fechas de la experiencia'}</h2>
      {schedule && <p>{description}{schedule.startTime ? ` · ${schedule.startTime}${schedule.endTime ? ` a ${schedule.endTime}` : ''}` : ''}</p>}
      {loading ? <p>Cargando disponibilidad…</p> : !next ? <p>El anfitrión aún no tiene próximas fechas programadas.</p> : <>
        <p className={s.legend}>Los días en verde corresponden a la programación disponible. Selecciona un solo día.</p>
        <div className={s.navigation}>
          <button type="button" aria-label="Mes anterior" disabled={month.isSameOrBefore(moment(), 'month')} onClick={() => this.setState({ month: month.clone().subtract(1, 'month') })}>‹</button>
          <span>Calendario de actividades</span>
          <button type="button" aria-label="Mes siguiente" onClick={() => this.setState({ month: month.clone().add(1, 'month') })}>›</button>
        </div>
        <div className={`${s.months} ${compact ? s.compact : ''}`}>
          {this.renderMonth(month)}{!compact && this.renderMonth(month.clone().add(1, 'month'))}
        </div>
        {selectedDate && this.canSelect(moment(selectedDate).format('YYYY-MM-DD')) && <p className={s.selection} aria-live="polite">Fecha elegida: {moment(selectedDate).locale('es').format('D [de] MMMM [de] YYYY')}</p>}
      </>}
    </section>;
  }
}

ExperienceCalendar.defaultProps = { formName: 'BookingForm', blockedDates: [] };
const mapState = (state, props) => {
  const name = props.formName || 'BookingForm';
  return { selectedDate: formValueSelector(name)(state, name === 'PaymentFormModal' ? 'checkIn' : 'startDate') };
};
export default withStyles(s)(connect(mapState, { change, checkAvailability })(ExperienceCalendar));
